import { render, staticRenderFns } from "./BillsList.vue?vue&type=template&id=5e2a4ce6"
import script from "./BillsList.vue?vue&type=script&lang=js"
export * from "./BillsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports